import axios from 'axios';
import {backendHost} from '../../config';

export const putBrands = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/brands`, params);
};